import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const DemoApi = {

	get(modelId) {

		return new Promise(function (resolve) {
			// A mock async action using setTimeout
			setTimeout(function () {
				resolve({
					data: {
						item: {
							id: modelId,
							title: "The Demo Model"
						},
						validationResults: {},
						beadModels: [
							{
								"tab": 0,
								"volledig": 1,
								"titel": "Tab1"
							},
							{
								"tab": 1,
								"volledig": 0,
								"titel": "Tab2"
							},
							{
								"tab": 2,
								"volledig": 1,
								"titel": "Tab3"
							},
							{
								"tab": 2,
								"volledig": 0,
								"titel": "Tab4"
							}]
					}
				});
			}, 1000);
		});

		// const serviceUrl = prependRoot('/demo/' + id, getApiRoot());
		// return axios.get(serviceUrl, {
		// 	headers: {
		// 		'accept': 'application/json'
		// 	}
		// });
	},
	getEmpty() {

		return new Promise(function (resolve) {
			// A mock async action using setTimeout
			setTimeout(function () {
				resolve({
					data: {
						item: {
							id: "emptyModelId",
							title: "The empty Model"
						},
						validationResults: {}
					}
				});
			}, 1000);
		});
		// const serviceUrl = prependRoot('/demo/empty/', getApiRoot());
		// return axios.get(serviceUrl, {
		// 	headers: {
		// 		'accept': 'application/json'
		// 	}
		// });
	},
	save(model, documents) {
		const serviceUrl = prependRoot('/demo', getApiRoot());
		return axios.put(serviceUrl, {
			item: model,
			documenten: documents
		},
			{
				headers: {
					'accept': 'application/json'
				}
			});
	}
};

export default DemoApi;
